import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Logo = ({
  className = null,
  isLoadingScreen = false,
}) => {
  const fullClassName = classNames({
    'vf-authentication__container__logo': !isLoadingScreen,
  }, className);

  return (
    <img
      alt="MyJobs"
      className={fullClassName}
      src="/assets/images/versafleet.png"
    />
  );
};

Logo.propTypes = {
  className: PropTypes.string,
  isLoadingScreen: PropTypes.bool,
};

Logo.displayName = 'Logo';

export default Logo;
